<footer class="site-footer">
  <div class="site-footer__top-accent"></div>

  <div class="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
    <div class="grid gap-10 md:grid-cols-2 lg:grid-cols-12 lg:gap-8">

      <!-- Brand -->
      <div class="space-y-5 lg:col-span-4">
        <app-brand-logo
          [light]="true"
          [markSize]="42"
          [wordmarkSize]="24"
          hostClass="items-center gap-3" />
        <p class="site-footer__desc max-w-sm text-sm">
          Connecting patients with verified caregivers and doctors across the Philippines.
          Quality care, right at your door.
        </p>
        <div class="flex items-center gap-2.5">
          <a
            href="mailto:support@GoCareMo.ph"
            class="site-footer__social"
            aria-label="Email GoCareMo support">
            <i class="pi pi-envelope text-sm"></i>
          </a>
        </div>
      </div>

      <!-- For Patients -->
      <div class="lg:col-span-2">
        <h3 class="site-footer__heading mb-4">For Patients</h3>
        <ul class="space-y-3 text-sm" style="list-style: none; padding: 0; margin: 0">
          <li><a routerLink="/search" class="site-footer__link">Find Providers</a></li>
          <li><a routerLink="/" fragment="how-it-works" class="site-footer__link">How It Works</a></li>
          <li>
            @if (canOpenPatientBookings) {
              <a [routerLink]="patientBookingsRoute" class="site-footer__link">My Bookings</a>
            } @else {
              <a routerLink="/auth/login" [queryParams]="{ returnUrl: '/patient/bookings' }" class="site-footer__link">My Bookings</a>
            }
          </li>
        </ul>
      </div>

      <!-- For Providers -->
      <div class="lg:col-span-2">
        <h3 class="site-footer__heading mb-4">For Providers</h3>
        <ul class="space-y-3 text-sm" style="list-style: none; padding: 0; margin: 0">
          <li><a routerLink="/auth/register" class="site-footer__link">Become a Provider</a></li>
          <li>
            @if (canOpenProviderDashboard) {
              <a [routerLink]="providerDashboardRoute" class="site-footer__link">Provider Dashboard</a>
            } @else {
              <a routerLink="/auth/login" [queryParams]="{ returnUrl: '/auth/register' }" class="site-footer__link">Provider Dashboard</a>
            }
          </li>
          <li><a routerLink="/search" class="site-footer__link">Browse Services</a></li>
        </ul>
      </div>

      <!-- Support -->
      <div class="lg:col-span-4">
        <h3 class="site-footer__heading mb-4">Support & Legal</h3>
        <ul class="space-y-3 text-sm" style="list-style: none; padding: 0; margin: 0">
          <li><a routerLink="/support" class="site-footer__link">Help Center</a></li>
          <li><a [href]="'mailto:' + supportEmail" class="site-footer__link">{{ supportEmail }}</a></li>
          <li><a routerLink="/privacy" class="site-footer__link">Privacy Policy</a></li>
          <li><a routerLink="/terms" class="site-footer__link">Terms of Service</a></li>
          <li><a routerLink="/provider-terms" class="site-footer__link">Provider Terms</a></li>
        </ul>
      </div>
    </div>

    <!-- Bottom Bar -->
    <div class="site-footer__divider mt-10 border-t pt-8">
      <div class="flex flex-col items-center justify-between gap-5 sm:flex-row">
        <p class="text-sm" style="color: rgba(255,255,255,0.5)">
          &copy; {{ currentYear }} GoCareMo. All rights reserved.
        </p>
        <div class="flex flex-wrap items-center justify-center gap-3">
          <span class="text-xs font-medium uppercase tracking-wide" style="color: rgba(255,255,255,0.45)">Pay with</span>
          <div class="flex items-center gap-2">
            <span class="site-footer__pay-badge site-footer__pay-badge--gcash">GCash</span>
            <span class="site-footer__pay-badge site-footer__pay-badge--maya">Maya</span>
            <span class="site-footer__pay-badge">Card</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>
